var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnderline = function SvgUnderline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8581 6.81818H16.0911V13.5597C16.0911 14.2557 15.927 14.8771 15.5989 15.424C15.2741 15.9676 14.815 16.3968 14.2218 16.7116C13.6285 17.0232 12.9325 17.179 12.1337 17.179C11.3349 17.179 10.6389 17.0232 10.0456 16.7116C9.45236 16.3968 8.99165 15.9676 8.66353 15.424C8.33872 14.8771 8.17631 14.2557 8.17631 13.5597V6.81818H9.40927V13.4602C9.40927 13.9574 9.51864 14.3999 9.73739 14.7876C9.95614 15.1721 10.2677 15.4754 10.6721 15.6974C11.0797 15.9162 11.5669 16.0256 12.1337 16.0256C12.7005 16.0256 13.1877 15.9162 13.5953 15.6974C14.003 15.4754 14.3146 15.1721 14.53 14.7876C14.7488 14.3999 14.8581 13.9574 14.8581 13.4602V6.81818Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.94336,
    y: 19,
    width: 11,
    height: 1,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnderline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "underline.b9b09406ff94f5693fabf9ddef26eb8f.svg";